@if (isOpen()) {
<div class="lc-overlay" (click)="close()">
<div class="lc-screen" (click)="$event.stopPropagation()">
  <!-- Header -->
  <div class="lc-header">
    <div class="lc-header-inner">
      @if (searchMode()) {
        <div class="lc-search">
          <span class="material-icons lc-search-ico">search</span>
          <input class="lc-search-input" type="text" placeholder="Search features..."
                 [ngModel]="query()" (ngModelChange)="onQuery($event)" autofocus />
        </div>
        <button class="lc-circle" (click)="onSearchToggle(false)" aria-label="Close search">
          <span class="material-icons">close</span>
        </button>
      } @else {
        <button class="lc-circle" (click)="close()" aria-label="Close">
          <span class="material-icons">close</span>
        </button>
        <div class="lc-title">Learning Center</div>
        <button class="lc-circle" (click)="onSearchToggle(true)" aria-label="Search">
          <span class="material-icons">search</span>
        </button>
      }
    </div>
  </div>

  <!-- List -->
  <div class="lc-list">
    <div class="lc-content">
      <p class="lc-intro">
        Interactive feature tours to help you get the most out of VectorMarine.
      </p>

      <div class="lc-grid">
        @for (entry of visibleEntries(); track $index) {
          @if (entry.kind === 'tour' && entry.tour; as tour) {
            <button class="lc-card" (click)="startTour(tour)"
                    [style.--tour-accent]="tour.accentColor || '#007AFF'">
              <div class="lc-card-ico"><span class="material-icons">{{ tour.icon }}</span></div>
              <div class="lc-card-body">
                <div class="lc-card-name">{{ tour.name }}</div>
                <div class="lc-card-desc">{{ tour.description }}</div>
              </div>
              <span class="material-icons lc-chevron">chevron_right</span>
            </button>
          }
          @if (entry.kind === 'group' && entry.group; as group) {
            <div class="lc-group" [class.expanded]="isExpanded(group.id)"
                 [style.--tour-accent]="group.accentColor || '#007AFF'">
              <button class="lc-group-head" (click)="toggleGroup(group.id)">
                <div class="lc-card-ico"><span class="material-icons">{{ group.icon }}</span></div>
                <div class="lc-card-body">
                  <div class="lc-card-name">{{ group.name }}</div>
                  <div class="lc-card-desc">{{ groupSubtitle(group) }}</div>
                </div>
                <span class="material-icons lc-caret" [class.open]="isExpanded(group.id)">
                  keyboard_arrow_down
                </span>
              </button>
              @if (isExpanded(group.id)) {
                <div class="lc-modules">
                  @for (m of group.tours; track m.id) {
                    <button class="lc-module" (click)="startTour(m)">
                      <div class="lc-module-ico"><span class="material-icons">{{ m.icon }}</span></div>
                      <div class="lc-card-body">
                        <div class="lc-module-name">{{ m.name }}</div>
                        <div class="lc-module-desc">{{ m.description }}</div>
                      </div>
                      <span class="material-icons lc-chevron">chevron_right</span>
                    </button>
                  }
                </div>
              }
            </div>
          }
          @if (entry.kind === 'action' && entry.action; as act) {
            <button class="lc-card lc-action-card" (click)="runAction(act)"
                    [style.--tour-accent]="act.accentColor || '#1F9D61'">
              <div class="lc-card-ico"><span class="material-icons">{{ act.icon }}</span></div>
              <div class="lc-card-body">
                <div class="lc-card-head-row">
                  <span class="lc-card-name">{{ act.title }}</span>
                  <span *ngIf="act.badge" class="lc-card-badge">{{ act.badge }}</span>
                </div>
                <div class="lc-card-desc">{{ act.description }}</div>
              </div>
              <span class="material-icons lc-chevron">chevron_right</span>
            </button>
          }
        }
      </div>
    </div>
  </div>
</div>
</div>
}
